module.exports = __webpack_public_path__ + "7ac988dd3c588ab7e594264810a28dc7.svg";